<template>
	<div>
		<div class="sm-flex sm-flex-justify-start">
			<div v-for="(obj, key) in inputs" :key="inputs[key]" class="sm-mb10 sm-input-block">
				<input type="text" :placeholder="obj" v-model="treeInputs[key]" @keydown="errorShow = false" class="sm-input-query">
				<p class="description" v-html="defData[key].desc"></p>
			</div>
		</div>
		<button @click="addValue" type="button" class="sm-button sm-edit-button">
			<i class="icon-plus"></i><span v-if="editMode">{{ editTitle }}</span><span v-else="editMode">{{ addTitle }}</span> {{ buttonTitle }}
		</button>
		<transition name="fade">
			<span class="sm-error" v-if="errorShow">{{ errorMsg }}</span>
		</transition>
		<div class="sm-mt10 sm-bt sm-pt10">With selected: 
			<button @click="groupRows" type="button" class="sm-button sm-edit-button sm-ml10"><span class="icon-list-add"></span>{{ groupTitle }}</button>
		</div>
		<ul class="sm-list">
			<li class="sm-li" v-for="(row, index) in list" :key="list[index]" :style="liPadding(row.level)">
				<div v-if="! row.relation" class="sm-flex sm-flex-align-center">
					<div class="sm-control">
						<input :id="checkboxId(index)" class="sm-checkbox" type="checkbox" v-model="checkedRows" :value="row"></input>
						<label :for="checkboxId(index)"></label>
						<a href="#" @click.prevent="editRow(row)"><span class="icon-pencil sm-edit sm-tax-buttons"></span></a>
						<a href="#" @click.prevent="deleteRow(row)"><span class="icon-cancel sm-del sm-tax-buttons"></span></a>
						<a v-if="row.level > 0" href="#" @click.prevent="ungroupRow(row)"><span class="icon-reply sm-level-up sm-tax-buttons"></span></a>
					</div>
					<div class="sm-bl-row sm-row" :index="row.level">
						<p class="sm-m0" v-if="typeof row[key] != 'undefined'" v-for="(obj, key) in defData" :key="defData[key]">
							<strong v-if="checkClass(key)" :class="checkPadding(obj.type)">{{ obj.title }}:</strong>
							<span v-else>{{ obj.title }}:</span> 
							<span v-if="( obj.type != 'array' && obj.type != 'date' && obj.type != 'intarray' )" class="value sm-ml10" :class="checkClass(key)">{{ row[key] }}</span>
							<span v-if="( obj.type == 'array' || obj.type == 'date' || obj.type == 'intarray' ) && typeof row[key] == 'object'" v-for="(item, index) in row[key]" :key="row[key][index]" class="sm-array-key sm-mr10">{{ item }}</span>
							<span v-if="( obj.type == 'array' || obj.type == 'date' || obj.type == 'intarray' ) && typeof row[key] == 'string'" class="sm-array-key sm-mr10">{{ row[key] }}</span>
							<a v-if="obj.type == 'param'" href="#" @click.prevent="changeParameter( row, key, obj.values )">
								<span class="icon-switch sm-switch sm-tax-buttons"></span>
							</a>
						</p>
					</div>
				</div>
				<div v-if="row.relation" class="sm-pl10 sm-bl-rel sm-rel" :index="row.level" :style="relationMargin(row.level)">
					<p class="sm-m0">
						<span>{{ relationTitle }}:</span> <span class="value sm-ml10">{{ row.relation }}</span>
						<a href="#" @click.prevent="changeRelation(row)"><span class="icon-switch sm-switch sm-tax-buttons"></span></a>
					</p>
				</div>
			</li>	
		</ul>
	</div>
</template>

<script>
import bus from './Bus.js';
export default {
	props: {
		componentId: String,
		buttonTitle: String,
		eventQuery: String,
		defData: {
			type: Object,
			default: function() {
				return {};
			}
		},
		def: {
			type: Object,
			default: function() {
				return {};
			}
		},
	},
	data: function() {
		return {
			values: {},
			treeInputs: {},
			errorMsg: '',
			currentRelation: '',
			currentRow: null,
			errorShow: false,
			editMode: false,
			flat: '',
			list: [],
			checkedRows: [],
			relationTitle: sm.relationship,
			groupTitle: sm.groupTitle,
			addTitle: sm.addTitle,
			editTitle: sm.editTitle,
		};
	},
	computed: {
		primaryKeys: function() {
			var arr = [];
			for (var obj in this.defData) {
				if (this.defData[obj].input) arr.push(obj);
			}
			return arr;
		},
		inputs: function() {
			var inps = {};
			for (var obj in this.defData) {
				if (this.defData[obj].input) inps[obj] = this.defData[obj].placeholder;
			}
			return inps;
		}
	},
	mounted: function() {
		var self = this;
		bus.$on('updateValues', function(id, values) {
			if (self.componentId == id) {
				self.values = values;
				self.flat = self.currentFlatMethod(self.values);
				self.list = self.getFlatValues(self.values);
				self.errorShow = false;
			}
		});
		this.values = this.def;
		this.flat = this.currentFlatMethod(this.values);
		this.list = this.getFlatValues(this.values);
	},
	methods: {
		checkboxId: function(index) {
			return 'sm-cb' + index;
		},
		relationMargin: function(level) {
			var margin = 97;
			if (level > 0) margin = 125;
			return 'margin-left:' + (margin) + 'px';
		},
		liPadding: function(level) {
			return 'padding-left:' + (40 * level) + 'px';
		},
		checkPadding: function(type) {
			var cl = null;
			if (type == 'array' || type == 'date' || type == 'intarray') cl = 'sm-pr10';
			return cl;
		},
		checkClass: function(type) {
			var cl = null;
			if (this.primaryKeys.indexOf(type) !== -1) cl = 'sm-array-key';
			return cl;
		},
		checkPrimaryKeys: function(obj1, obj2) {
			var checked = true;
			for (var i = 0; i < this.primaryKeys.length; i++) {
				var item = this.primaryKeys[i];
				if (obj1[item] != obj2[item]) checked = false;
			}
			return checked;
		},
		assignPrimaryKeys: function(obj1, obj2) {
			for (var i = 0; i < this.primaryKeys.length; i++) {
				var item = this.primaryKeys[i];
				obj1[item] = obj2[item];
			}
		},
		recurringSwitch: function(objs, obj, parent, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (objs == parent && Object.keys(objs).length - 1 > Object.keys(obj).length) {
						var currentIndex;
						for (var ob in objs) {
							if (typeof objs[ob] != 'string') {
								for (var oo in obj) {
									if (this.checkPrimaryKeys(objs[ob], obj[oo])) {
										if (!currentIndex) currentIndex = ob;
										if (ob < currentIndex) currentIndex = ob;
										delete objs[ob];
										break;
									}
								}
							}
						}
						objs[currentIndex] = obj;
						break;
					} else {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringSwitch(objs[o], obj, parent, next_level);
							recurring = false;
						}
					}
				}
			}
		},
		recurringRowEdit: function(objs, obj, newObj, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (this.checkPrimaryKeys(objs[o], obj) && level == obj.level) {
						this.assignPrimaryKeys(objs[o], newObj);
						break;
					} else {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringRowEdit(objs[o], obj, newObj, next_level);
							recurring = false;
						}
					}
				}
			}
		},
		recurringRowDelete: function(objs, obj, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var currentKey, subKey;
			var recurring = false;
			var result = null;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (this.checkPrimaryKeys(objs[o], obj) && level == obj.level) {
						delete objs[o];
					} else {
						currentKey = o;
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							var responce = this.recurringRowDelete(objs[o], obj, next_level);
							if (responce) {
								subKey = o;
								result = responce;
							}
							recurring = false;
						}
					}
				}
			}
			if (result && subKey) {
				objs[subKey] = result;
			}
			if (Object.keys(objs).length < 3 && objs.hasOwnProperty('relation')) {
				return objs[currentKey];
			}
			return null;
		},
		recurringChangeRelation: function(objs, obj, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (o == 'relation') {
					if (level == obj.level && obj.parent == objs) {
						if (objs[o] == 'AND') {
							objs[o] = 'OR';
						} else {
							objs[o] = 'AND';
						}
					}
				} else {
					for (var sub in objs[o]) {
						if (sub == parseInt(sub)) {
							recurring = true;
							break;
						}
					}
					if (recurring) {
						this.recurringChangeRelation(objs[o], obj, next_level);
						recurring = false;
					}
				}
			}
		},
		recurringChangeParameter: function(objs, obj, key, values, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (this.checkPrimaryKeys(objs[o], obj) && level == obj.level) {
						if (!objs[o][key]) {
							objs[o][key] = values[0];
						} else {
							var newOp;
							for (var index = 0; index < values.length; index++) {
								var op = values[index];
								if (objs[o][key] == op) {
									if (index < values.length - 1) {
										newOp = values[index + 1];
									} else {
										newOp = values[0];
									}
								}
							}
							if (!newOp) newOp = values[0];
							objs[o][key] = newOp;
						}
						break;
					} else {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringChangeParameter(objs[o], obj, key, values, next_level);
							recurring = false;
						}
					}
				}
			}
		},
		getFlatValues: function(rec, parent, level) {
			if (!level) level = 0;
			if (!parent) parent = this.values;
			var objs = [];
			var next_level = level + 1;
			for (var item in rec) {
				if (typeof rec[item] != 'string') {
					var obj = null;
					for (var sub in rec[item]) {
						if (sub == parseInt(sub)) {
							var temp = {};
							var newParent = rec[item];
							temp[0] = rec[item][sub];
							temp = this.getFlatValues(temp, newParent, next_level);
							for (var index = 0; index < temp.length; index++) {
								objs.push(temp[index]);
							}
						} else if (sub == 'relation') {
							var rel = {};
							rel.relation = rec[item][sub];
							rel.level = next_level;
							rel.parent = rec[item];
							objs.push(rel);
						} else {
							obj = Object.assign({}, rec[item]);
							obj.level = level;
							obj.parent = parent;
						}
					}
					if (obj) objs.push(obj);
				} else {
					var topRel = {};
					topRel.relation = rec[item];
					topRel.level = level;
					topRel.parent = rec;
					objs.push(topRel);
				}
			}
			return objs;
		},
		recurringLevelUp: function(objs, obj, parent, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (objs[o] == parent) {
						var index = Object.keys(objs).length - 1;
						objs[index] = obj;
						delete objs[index].level;
						delete objs[index].parent;
						for (var ob in objs[o]) {
							if (typeof objs[ob] != 'string') {
								if (this.checkPrimaryKeys(objs[o][ob], obj)) {
									delete objs[o][ob];
									if (Object.keys(objs[o]).length - 1 < 2) {
										objs[o] = objs[o][Object.keys(objs[o])[0]];
									}
									break;
								}
							}
						}
						break;
					} else {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringLevelUp(objs[o], obj, parent, next_level);
							recurring = false;
						}
					}
				}
			}
		},
		recurringCheckRelation: function(objs, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			var done = false;
			var count;
			for (var o in objs) {
				if (objs.hasOwnProperty(o)) {
					if (!done) {
						count = Object.keys(objs).length;
						if (count < 3 && objs.hasOwnProperty('relation')) {
							delete objs.relation;
						} else if (count > 1 && !objs.hasOwnProperty('relation')) {
							objs.relation = 'AND';
						}
						done = true;
					}
					if (typeof objs[o] != 'string') {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringCheckRelation(objs[o], next_level);
							recurring = false;
						}
					}
				}
			}
			return count;
		},
		normalizeValues: function(objs) {
			var temp = {};
			var count = 0;
			var recurring = false;
			for (var o in objs) {
				if (o == parseInt(o)) {
					temp[count] = objs[o];
					for (var sub in objs[o]) {
						if (sub == parseInt(sub)) {
							recurring = true;
							break;
						}
					}
					if (recurring) {
						temp[count] = this.normalizeValues(objs[o]);
						recurring = false;
					}
					count++;
				} else {
					temp[o] = objs[o];
				}
			}
			return temp;
		},
		currentFlatMethod: function(array) {
			if (Object.keys(array).length === 0) return '';
			return JSON.stringify(array);
		},
		afterChange: function(update) {
			if (update) {
				this.recurringCheckRelation(this.values);
				this.values = Object.assign({}, this.normalizeValues(this.values));
			}
			this.flat = this.currentFlatMethod(this.values);
			this.list = this.getFlatValues(this.values);
			this.$emit('changed', this.flat, this.eventQuery);
		},
		addValue: function() {
			var self = this;
			if (this.validate()) {
				var newObj = {};
				for (var df in this.defData) {
					if (this.defData.hasOwnProperty(df)) {
						for (var index = 0; index < this.primaryKeys.length; index++) {
							var item = this.primaryKeys[index];
							if (df == item && self.treeInputs[item]) {
								if (self.defData[df].type != 'date') {
									newObj[df] = self.convertTerms(self.treeInputs[item]);
								} else {
									newObj[df] = self.convertDate(self.treeInputs[item]);
								}
							}
						}
						if (this.defData[df].type == 'param') newObj[df] = this.defData[df].values[0];
					}
				}
				if (!this.editMode) {
					var count = 0;
					for (var value in this.values) {
						if (this.values.hasOwnProperty(value)) {
							count++;
							if (typeof this.values[value] == 'string') {
								count--;
							}
						}
					}
					this.values[count] = newObj;
					if (count > 0) {
						var obj = this.values;
						this.values = Object.assign({}, this.values, obj);
					}
				} else {
					this.recurringRowEdit(this.values, this.currentRow, newObj);
					this.editMode = false;
					this.currentRow = null;
				}
				this.treeInputs = {};
				this.afterChange(true);
			}
		},
		editRow: function(row) {
			var self = this;
			this.errorShow = false;
			this.editMode = true;
			this.currentRow = row;
			for (var df in this.defData) {
				if (this.defData.hasOwnProperty(df)) {
					for (var index = 0; index < this.primaryKeys.length; index++) {
						var item = this.primaryKeys[index];
						if (df == item) {
							if (self.defData[df].type != 'date') {
								self.treeInputs[item] = self.flatTerms(row[item]);
							} else {
								self.treeInputs[item] = self.flatDate(row[item]);
							}
						}
					}
				}
			}
		},
		groupRows: function() {
			if (this.checkedRows.length > 1) {
				var sameLevels = true;
				var sameParents = true;
				var currentLevel = this.checkedRows[0].level;
				var currentParent = this.checkedRows[0].parent;
				var newObj = {};
				var count = 0;
				for (var index = 0; index < this.checkedRows.length; index++) {
					var row = this.checkedRows[index];
					if (row.level != currentLevel) {
						sameLevels = false;
						sameParents = false;
					} else if (row.parent != currentParent) sameParents = false;
					newObj[count] = Object.assign({}, row);
					delete newObj[count].level;
					delete newObj[count].parent;
					count++;
				}
				if (sameParents && sameLevels) {
					this.recurringSwitch(this.values, newObj, currentParent);
				}
				this.checkedRows = [];
				this.afterChange(true);
			}
		},
		ungroupRow: function(row) {
			this.recurringLevelUp(this.values, row, row.parent);
			this.afterChange(true);
		},
		deleteRow: function(row) {
			this.recurringRowDelete(this.values, row);
			this.afterChange(true);
		},
		changeRelation: function(row) {
			this.recurringChangeRelation(this.values, row);
			this.afterChange(false);
		},
		changeParameter: function(row, param, values) {
			this.recurringChangeParameter(this.values, row, param, values);
			this.afterChange(false);
		},
		convertTerms: function(values) {
			var arr = values.split(',');
			if (arr.length != 1) {
				var temp_arr = [];
				for (var index = 0; index < arr.length; index++) {
					var item = arr[index];
					item = item.trim();
					if (item && item.length > 0) temp_arr.push(item);
				}
				return temp_arr;
			} else {
				return arr[0];
			}
		},
		convertDate: function(values) {
			if (!/^({%[a-zA-Z0-9_| ]*%})$/.test(values)) {
				var arr = values.split('|');
				if (arr[0] == parseInt(arr[0])) {
					var temp_arr = {};
					if (!arr[1]) arr[1] = '1';
					if (!arr[2]) arr[2] = '1';
					temp_arr.year = arr[0].trim();
					temp_arr.month = arr[1].trim();
					temp_arr.day = arr[2].trim();
					return temp_arr;
				} else {
					return arr[0].trim();
				}
			} else {
				return values;
			}
		},
		convertInts: function(values) {
			if (values == parseInt(values)) return parseInt(values);
			return null;
		},
		flatTerms: function(values) {
			if (typeof values == 'object') values = values.join();
			return values;
		},
		flatDate: function(values) {
			if (typeof values == 'object') {
				var arr = [];
				for (var prop in values) {
					if (values.hasOwnProperty(prop)) {
						arr.push(values[prop]);
					}
				}
				values = arr.join('|');
			}
			return values;
		},
		error: function(type) {
			this.errorShow = false;
			switch (type) {
				case 'badInput':
					this.errorMsg = sm.errorBadInput;
					break;
				case 'duplicates':
					this.errorMsg = sm.errorDuplicatesValues;
					break;
				default:
					this.errorMsg = sm.errorDefault;
					break;
			}
			this.errorShow = true;
		},
		validate: function() {
			var self = this;
			var valid = true;
			var notEmpty = false;
			var error = this.error;
			var regString = /^[A-Za-z0-9-_{}%,|. ]+$/;
			for (var df in this.defData) {
				if (this.defData.hasOwnProperty(df)) {
					for (var index = 0; index < this.primaryKeys.length; index++) {
						var item = this.primaryKeys[index];
						if (typeof self.treeInputs[item] != 'undefined') {
							if (self.treeInputs[item] !== '') notEmpty = true;
							if (df == item) {
								switch (self.defData[df].type) {
									case 'int':
										if (!self.defData[df].reg.test(self.treeInputs[item]) && self.treeInputs[item] !== '') {
											error('badInput');
											valid = false;
										}
										break;
									case 'intarray':
										if (self.treeInputs[item] !== '') {
											var arr = self.treeInputs[item].split(',');
											for (var i = 0; i < arr.length; i++) {
												if (!self.defData[df].reg.test(arr[i].trim())) {
													error('badInput');
													valid = false;
												}
											}
										}
										break;
									case 'string':
									/*
									case 'array':
										if (!regString.test(self.treeInputs[item]) && self.treeInputs[item] !== '') {
											error('badInput');
											valid = false;
										}
										break;
									*/
									case 'date':
										if (self.treeInputs[item] !== '') {
											if (!/^({%[a-zA-Z0-9_| ]*%})$/.test(self.treeInputs[item])) {
												var date = self.treeInputs[item].split('|');
												if (/^(19|20)\d{2}$/.test(date[0].trim())) {
													if (!date[1]) date[1] = '1';
													if (!date[2]) date[2] = '1';
													if (!/^(1[0-2]|[1-9])$/.test(date[1].trim())) {
														error('badInput');
														valid = false;
													}
													if (!/^([1-9]|[1-2][0-9]|3[0-1])$/.test(date[2].trim())) {
														error('badInput');
														valid = false;
													}
												} else {
													if (!regString.test(date[0].trim())) {
														error('badInput');
														valid = false;
													}
												}
											}
										}
										break;
								}
								if (self.defData[df].req && self.defData[df].req === true && self.treeInputs[item] === '') {
									error('badInput');
									valid = false;
								}
							}
						} else {
							if (df == item) {
								if (self.defData[df].req && self.defData[df].req === true) {
									error('badInput');
									valid = false;
								}
							}
						}
					}
				}
			}
			if (!notEmpty) {
				error('badInput');
				valid = false;
			}
			return valid;
		}
	}
};
</script>


// WEBPACK FOOTER //
// TreeInput.vue?405c2100